export enum AccessRoleEnum {
  ADMINSTRATOR = 'Administrator',
  MANAGER = 'Manager',
  CUSTOMER_SERVICE = 'Customer Service',
  APIKEY = 'APIKEY',
}
